import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { AuthLayout } from '@/components/layout/AuthLayout';
import { ProtectedRoute } from '@/routes/ProtectedRoute';

import LoginPage from '@/pages/auth/LoginPage';
import CallbackPage from '@/pages/auth/CallbackPage';
import DashboardPage from '@/pages/dashboard/DashboardPage';
import CustomersPage from '@/pages/customers/CustomersPage';
import CustomerNewPage from '@/pages/customers/new/CustomerNewPage';
import CustomerDetailPage from '@/pages/customers/detail/CustomerDetailPage';
import ContractsPage from '@/pages/contracts/ContractsPage';
import ContractNewPage from '@/pages/contracts/new/ContractNewPage';
import PartnerContractsPage from '@/pages/contracts/PartnerContractsPage';
import ContractDetailPage from '@/pages/contracts/detail/ContractDetailPage';
import AffiliatesPage from '@/pages/affiliates/AffiliatesPage';
import EmployeeAffiliatesPage from '@/pages/affiliates/EmployeeAffiliatesPage';
import AffiliateNewPage from '@/pages/affiliates/new/AffiliateNewPage';
import AffiliateDetailPage from '@/pages/affiliates/detail/AffiliateDetailPage';
import CommissionPoliciesPage from '@/pages/affiliates/commission-policies/CommissionPoliciesPage';
import ServicesPage from '@/pages/services/ServicesPage';
import ServiceDetailPage from '@/pages/services/detail/ServiceDetailPage';
import SlaDashboardPage from '@/pages/services/sla-dashboard-page';
import TicketsPage from '@/pages/tickets/TicketsPage';
import TicketDetailPage from '@/pages/tickets/detail/TicketDetailPage';
import TicketNewPage from '@/pages/tickets/new/TicketNewPage';
import TicketEditPage from '@/pages/tickets/edit/TicketEditPage';
import InvoicesPage from '@/pages/invoices/InvoicesPage';
import InvoiceDetailPage from '@/pages/invoices/detail/InvoiceDetailPage';
import CapacitiesDashboardPage from '@/pages/capacities/dashboard/CapacitiesDashboardPage';
import CapacitySuppliersPage from '@/pages/capacities/suppliers/CapacitySuppliersPage';
import CapacitySupplierDetailPage from '@/pages/capacities/suppliers/CapacitySupplierDetailPage';
import CapacityModelsPage from '@/pages/capacities/models/CapacityModelsPage';
import CapacityModelDetailPage from '@/pages/capacities/models/CapacityModelDetailPage';
import CapacityLocationsPage from '@/pages/capacities/locations/CapacityLocationsPage';
import CapacityLocationDetailPage from '@/pages/capacities/locations/CapacityLocationDetailPage';
import CapacityItemsPage from '@/pages/capacities/items/CapacityItemsPage';
import CapacityEquipmentDetailPage from '@/pages/capacities/equipment/CapacityEquipmentDetailPage';
import CapacityComponentDetailPage from '@/pages/capacities/components/CapacityComponentDetailPage';
import CapacityRacksPage from '@/pages/capacities/racks/CapacityRacksPage';
import CapacityRackDetailPage from '@/pages/capacities/racks/CapacityRackDetailPage';
import CapacityProcessesPage from '@/pages/capacities/processes/CapacityProcessesPage';
import CapacityProcessNewPage from '@/pages/capacities/processes/new/CapacityProcessNewPage';
import CapacityProcessDetailPage from '@/pages/capacities/processes/CapacityProcessDetailPage';
import CapacitySupplierFormPage from '@/pages/capacities/suppliers/CapacitySupplierFormPage';
import CapacityModelFormPage from '@/pages/capacities/models/CapacityModelFormPage';
import CapacityRackFormPage from '@/pages/capacities/racks/RackForm';
import CloudZoneDetailPage from '@/pages/capacities/cloud/CloudZoneDetailPage';
import CloudInstanceDetailPage from '@/pages/capacities/cloud/CloudInstanceDetailPage';
import AccountHome from '@/pages/account/AccountHome';
import AccountInfoPage from '@/pages/account/AccountInfoPage';
import MyIncomesPage from '@/pages/account/MyIncomesPage';
import ReferralPage from '@/pages/account/ReferralPage';
import RegulationsPage from '@/pages/account/RegulationsPage';
import VCardsPage from '@/pages/account/VCardsPage';
import VCardPublicPage from '@/pages/account/VCardPublicPage';
import WorkdaysPage from '@/pages/account/WorkdaysPage';
import DayoffsPage from '@/pages/account/DayoffsPage';
import BusinessesPage from '@/pages/account/BusinessesPage';
import OncallPage from '@/pages/account/OncallPage';
import PasswordSecurityPage from '@/pages/account/PasswordSecurityPage';
import AccountContractsPage from '@/pages/account/AccountContractsPage';
import WorkingProcessPage from '@/pages/account/WorkingProcessPage';
import MyRatingsPage from '@/pages/account/MyRatingsPage';
import CustomerEventsPage from '@/pages/account/CustomerEventsPage';
import OperationsDashboardPage from '@/pages/operations/OperationsDashboardPage';
import OperationsPage from '@/pages/operations/OperationsPage';
import OperationsOrgsPage from '@/pages/operations/orgs/OperationsOrgsPage';
import OperationsOrgDetailPage from '@/pages/operations/orgs/OperationsOrgDetailPage';
import OperationsServiceDetailPage from '@/pages/operations/detail/OperationsServiceDetailPage';
import OperationsCdnPage from '@/pages/operations/OperationsCdnPage';
import OperationsInstancesPage from '@/pages/operations/resources/OperationsInstancesPage';
import OperationsDomainsPage from '@/pages/operations/resources/OperationsDomainsPage';
import ActAsCdnDomainDetailPage from '@/pages/operations/detail/cdn/act-as-cdn-domain-detail-page';
import ActAsWaapDetailPage from '@/pages/operations/detail/waap/act-as-waap-detail-page';
import TechnicalReportPage from '@/pages/operations/technical/TechnicalReportPage';
import ReconciliationListPage from '@/pages/reconciliation/reconciliation-list-page';
import ReconciliationDetailPage from '@/pages/reconciliation/reconciliation-detail-page';
import ReconciliationBatchBuilderPage from '@/pages/reconciliation/reconciliation-batch-builder';
import ContractNegotiationsPage from '@/pages/contracts/negotiations/ContractNegotiationsPage';
import ContractNegotiationDetailPage from '@/pages/contracts/negotiations/detail/ContractNegotiationDetailPage';
import ContractSamplesPage from '@/pages/contracts/samples/ContractSamplesPage';
import ResellersPage from '@/pages/reseller/ResellersPage';
import ResellerNewPage from '@/pages/reseller/new/ResellerNewPage';
import ResellerDetailPage from '@/pages/reseller/detail/ResellerDetailPage';
import PromosPage from '@/pages/promos/PromosPage';
import PromoNewPage from '@/pages/promos/new/PromoNewPage';
import PromoDetailPage from '@/pages/promos/detail/PromoDetailPage';
import DayoffsAdminPage from '@/pages/hrm/dayoffs/DayoffsAdminPage';
import DayoffsAdminDetailPage from '@/pages/hrm/dayoffs/DayoffsAdminDetailPage';
import BusinessesAdminPage from '@/pages/hrm/businesses/BusinessesAdminPage';
import BusinessesAdminDetailPage from '@/pages/hrm/businesses/BusinessesAdminDetailPage';
import SurveysPage from '@/pages/surveys/SurveysPage';
import SurveyRecordNewPage from '@/pages/surveys/records/new/SurveyRecordNewPage';
import SurveyRecordDetailPage from '@/pages/surveys/records/detail/SurveyRecordDetailPage';
import ProductServicesPage from '@/pages/settings/product-services/ProductServicesPage';
import SlaTemplatesPage from '@/pages/settings/sla-templates-page';
import EmployeesPage from '@/pages/hrm/employees/EmployeesPage';
import EmployeeDetailPage from '@/pages/hrm/employees/detail/EmployeeDetailPage';
import ContactsPage from '@/pages/contacts/ContactsPage';
import ContactDetailPage from '@/pages/contacts/ContactDetailPage';
import JobsPage from '@/pages/jobs/JobsPage';
import JobFormPage from '@/pages/jobs/JobFormPage';
import JobCategoriesPage from '@/pages/jobs/categories/JobCategoriesPage';
import JobCategoryFormPage from '@/pages/jobs/categories/JobCategoryFormPage';
import NotFoundPage from '@/pages/NotFoundPage';

export const router = createBrowserRouter(
  [
    {
      path: '/auth',
      element: <AuthLayout />,
      children: [
        { index: true, element: <Navigate to="/auth/login" replace /> },
        { path: 'login', element: <LoginPage /> },
        { path: 'callback', element: <CallbackPage /> },
      ],
    },
    // Public branded VCard preview (QR / copy-link target) — no app chrome, no auth.
    { path: '/vcard/:uuid', element: <VCardPublicPage /> },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      ),
      children: [
        { index: true, element: <DashboardPage /> },
        { path: 'customers', element: <CustomersPage /> },
        { path: 'customers/new', element: <CustomerNewPage /> },
        { path: 'customers/:id', element: <CustomerDetailPage /> },
        // Contracts — customer (sell-side) + partner (buy-side) lists + detail.
        { path: 'contracts', element: <ContractsPage /> },
        { path: 'contracts/new', element: <ContractNewPage /> },
        { path: 'contracts/partners', element: <PartnerContractsPage /> },
        // Negotiations — static path must precede `contracts/:id`.
        { path: 'contracts/negotiations', element: <ContractNegotiationsPage /> },
        { path: 'contracts/negotiations/:id', element: <ContractNegotiationDetailPage /> },
        // Sample/template contracts — static path must precede `contracts/:id`.
        { path: 'contracts/samples', element: <ContractSamplesPage /> },
        { path: 'contracts/:id', element: <ContractDetailPage /> },
        // Resellers — official/candidate list + create + 4-tab detail.
        { path: 'resellers', element: <ResellersPage /> },
        { path: 'resellers/new', element: <ResellerNewPage /> },
        { path: 'resellers/:id', element: <ResellerDetailPage /> },
        // Promos — discount-code list + create + detail (overview + usage history).
        { path: 'promos', element: <PromosPage /> },
        { path: 'promos/new', element: <PromoNewPage /> },
        { path: 'promos/:id', element: <PromoDetailPage /> },
        // Affiliates — customer/partner list (+ candidates), employee list, create,
        // global commission-policy manager, detail (7 tabs).
        { path: 'affiliates', element: <AffiliatesPage /> },
        { path: 'affiliates/employees', element: <EmployeeAffiliatesPage /> },
        { path: 'affiliates/new', element: <AffiliateNewPage /> },
        { path: 'affiliates/commission-policies', element: <CommissionPoliciesPage /> },
        { path: 'affiliates/:id', element: <AffiliateDetailPage /> },
        // Services — global list (all / waiting-confirm / POC / device-liquidation).
        { path: 'services', element: <ServicesPage /> },
        { path: 'services/sla-dashboard', element: <SlaDashboardPage /> },
        { path: 'services/:id', element: <ServiceDetailPage /> },

        { path: 'tickets', element: <TicketsPage /> },
        { path: 'tickets/new', element: <TicketNewPage /> },
        { path: 'tickets/:id', element: <TicketDetailPage /> },
        { path: 'tickets/:id/edit', element: <TicketEditPage /> },
        // Invoices — global list + detail.
        { path: 'invoices', element: <InvoicesPage /> },
        { path: 'invoices/:id', element: <InvoiceDetailPage /> },
        // Capacities & Resources — 2-tab dashboard landing (Physical Inventory + Cloud Resources) + masters.
        { path: 'capacities', element: <CapacitiesDashboardPage /> },
        { path: 'capacities/suppliers', element: <CapacitySuppliersPage /> },
        { path: 'capacities/suppliers/new', element: <CapacitySupplierFormPage /> },
        { path: 'capacities/suppliers/:id', element: <CapacitySupplierDetailPage /> },
        { path: 'capacities/suppliers/:id/edit', element: <CapacitySupplierFormPage /> },
        { path: 'capacities/models', element: <CapacityModelsPage /> },
        { path: 'capacities/models/new', element: <CapacityModelFormPage /> },
        { path: 'capacities/models/:id', element: <CapacityModelDetailPage /> },
        { path: 'capacities/models/:id/edit', element: <CapacityModelFormPage /> },
        { path: 'capacities/locations', element: <CapacityLocationsPage /> },
        { path: 'capacities/locations/:id', element: <CapacityLocationDetailPage /> },
        { path: 'capacities/items', element: <CapacityItemsPage /> },
        { path: 'capacities/equipment/:id', element: <CapacityEquipmentDetailPage /> },
        { path: 'capacities/components/:id', element: <CapacityComponentDetailPage /> },
        { path: 'capacities/racks', element: <CapacityRacksPage /> },
        { path: 'capacities/racks/new', element: <CapacityRackFormPage /> },
        { path: 'capacities/racks/:id', element: <CapacityRackDetailPage /> },
        { path: 'capacities/racks/:id/edit', element: <CapacityRackFormPage /> },
        { path: 'capacities/processes', element: <CapacityProcessesPage /> },
        { path: 'capacities/processes/new', element: <CapacityProcessNewPage /> },
        { path: 'capacities/processes/:id/edit', element: <CapacityProcessNewPage /> },
        { path: 'capacities/processes/:id', element: <CapacityProcessDetailPage /> },
        { path: 'capacities/cloud/zones/:id', element: <CloudZoneDetailPage /> },
        { path: 'capacities/cloud/instances/:id', element: <CloudInstanceDetailPage /> },
        // Account — landing + standalone sub-pages (each its own route).
        { path: 'account', element: <AccountHome /> },
        { path: 'account/info', element: <AccountInfoPage /> },
        { path: 'account/password-security', element: <PasswordSecurityPage /> },
        { path: 'account/contracts', element: <AccountContractsPage /> },
        { path: 'account/working-process', element: <WorkingProcessPage /> },
        { path: 'account/my-ratings', element: <MyRatingsPage /> },
        { path: 'account/customer-events', element: <CustomerEventsPage /> },
        { path: 'account/vcards', element: <VCardsPage /> },
        { path: 'account/workdays', element: <WorkdaysPage /> },
        { path: 'account/dayoffs', element: <DayoffsPage /> },
        { path: 'account/businesses', element: <BusinessesPage /> },
        { path: 'account/oncall', element: <OncallPage /> },
        { path: 'account/my-incomes', element: <MyIncomesPage /> },
        { path: 'account/referral', element: <ReferralPage /> },
        { path: 'account/regulations', element: <RegulationsPage /> },
        // Operations — internal cross-org service management (employee-only).
        // /operations = platform dashboard (stats, trend, top orgs).
        // /operations/services = full service list (former landing).
        // /operations/orgs = org list + /orgs/:orgId detail.
        { path: 'operations', element: <OperationsDashboardPage /> },
        { path: 'operations/services', element: <OperationsPage /> },
        { path: 'operations/cdn', element: <OperationsCdnPage /> },
        // Legacy split routes → merged CDN page (preserve old bookmarks/nav).
        { path: 'operations/cdn-gaps', element: <Navigate to="/operations/cdn?tab=gaps" replace /> },
        { path: 'operations/cdn-connections', element: <Navigate to="/operations/cdn?tab=connections" replace /> },
        // Cross-org resource inventory (Tech console): flat Instances + Domains lists.
        { path: 'operations/instances', element: <OperationsInstancesPage /> },
        { path: 'operations/domains', element: <OperationsDomainsPage /> },
        { path: 'operations/services/:id', element: <OperationsServiceDetailPage /> },
        // CDN domain detail — act-as context (Wave A1 Overview + A2–A4 stubs).
        // Reachable from the "CDN (as customer)" tab's domain list rows.
        { path: 'operations/act-as/cdn/:domainId', element: <ActAsCdnDomainDetailPage /> },
        // WAAP service detail — act-as context (Wave B1 Overview/Websites/Logs + B2–B4 stubs).
        // Reachable from the "WAAP (as customer)" tab's service list rows.
        { path: 'operations/act-as/waap/:serviceId', element: <ActAsWaapDetailPage /> },
        { path: 'operations/orgs', element: <OperationsOrgsPage /> },
        { path: 'operations/orgs/:orgId', element: <OperationsOrgDetailPage /> },
        // Technical › WAF Reports — was a dead nav link (404); served by the automation service.
        { path: 'technical/report', element: <TechnicalReportPage /> },
        // Reconciliation — kỳ đối soát list + detail + batch builder.
        // Static `batches/:id` must precede the `:cohortKey` catch so "batches"
        // is not captured as a cohort key.
        { path: 'reconciliation', element: <ReconciliationListPage /> },
        { path: 'reconciliation/batches/:id', element: <ReconciliationBatchBuilderPage /> },
        { path: 'reconciliation/:cohortKey', element: <ReconciliationDetailPage /> },
        // HRM — Day-offs admin (cross-employee view at /dayoffs).
        { path: 'dayoffs', element: <DayoffsAdminPage /> },
        { path: 'dayoffs/:id', element: <DayoffsAdminDetailPage /> },
        // HRM — Businesses admin (cross-employee view).
        { path: 'businesses', element: <BusinessesAdminPage /> },
        { path: 'businesses/:id', element: <BusinessesAdminDetailPage /> },
        // Surveys — customer satisfaction records list + create + detail.
        { path: 'surveys', element: <SurveysPage /> },
        { path: 'surveys/records/new', element: <SurveyRecordNewPage /> },
        { path: 'surveys/records/:recordId', element: <SurveyRecordDetailPage /> },
        // Settings — product & services admin (3 tabs).
        { path: 'settings/product-services', element: <ProductServicesPage /> },
        { path: 'settings/sla-templates', element: <SlaTemplatesPage /> },
        // HRM — Employees list (3 tabs) + read-only 8-tab detail.
        { path: 'employees', element: <EmployeesPage /> },
        { path: 'employees/:id', element: <EmployeeDetailPage /> },
        // Marketing — leads/contacts list (3 tabs) + detail + statistics.
        { path: 'contacts', element: <ContactsPage /> },
        { path: 'contacts/:id', element: <ContactDetailPage /> },
        // Jobs — postings + categories. Static sub-paths precede /jobs/:jobId.
        { path: 'jobs', element: <JobsPage /> },
        { path: 'jobs/new', element: <JobFormPage /> },
        { path: 'jobs/categories', element: <JobCategoriesPage /> },
        { path: 'jobs/categories/new', element: <JobCategoryFormPage /> },
        { path: 'jobs/categories/:categoryId', element: <JobCategoryFormPage /> },
        { path: 'jobs/:jobId', element: <JobFormPage /> },
        // Module routes ported from datacentral-client-v4 land here.
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ],
  {
    future: {
      v7_relativeSplatPath: true,
    },
  },
);

export default router;
